import React, { useState } from 'react';
import '../template-file-css/document-file-template.css';
import { Error } from "@progress/kendo-react-labels";
import { Upload } from "@progress/kendo-react-upload";
export const AI_BIRP = ({ itemsRef, showErrorFor }) => {
  // Attachments
  const [attachments, setAttachments] = useState([]);
  const [uploadError, setUploadError] = useState(false);
  const serviceProvided = [
    {
      label: "Community Support (CSI)",
      value: "Community Support (CSI)",
    },
    {
      label: "Psychosocial Rehabilitation Individual",
      value: "Psychosocial Rehabilitation Individual",
    },
    {
      label: "Family Skills",
      value: "Family Skills",
    },
    {
      label: "Family Therapy",
      value: "Family Therapy",
    },
    {
      label: "Intensive Family Intervention",
      value: "Intensive Family Intervention",
    },
    {
      label: "Case Management",
      value: "Case Management",
    },
    {
      label: "Addictive Disease Support",
      value: "Addictive Disease Support",
    },
    {
      label: "Crisis Intervention",
      value: "Crisis Intervention",
    },
  ];

  /* ============================= Event functions ============================= */
  const onAdd = (event) => {
    setAttachments(event.newState);
    setUploadError(false);
  };
  const onRemove = (event) => {
    setAttachments(event.newState);
  };

  const onStatusChange = (event) => {
    setAttachments(event.newState);
  };
  return (
    <form id='AI_BIRP' className='file-pdf-document'>
      <div className='file-template mt-0'>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 p-0">
              <p className='mt-0 mb-0'>
                <span className='session-summary'>Staff Place Of Service: </span>
                <input type='text' id='txtStaffPlaceOfService' name="staffPlaceOfService" className='add-only mt-3 ai-notes-text'></input>
              </p>
              <p className='mt-0 mb-0'>
                <h6>Service Provided:</h6>
                <select className='form-select form-select-lg mb-3' name="serviceProvided" id="serviceProvided" style={{ width: "100%" }}>
                  <option className='add-only form-control' value="individualTherapy">Individual Therapy</option>
                  <option className='add-only form-control' value="telehealth">Telehealth</option>
                  <option className='add-only form-control' value="communityBased">Community Based</option>
                  <option className='add-only form-control' value="inHome">In-Home</option>
                </select>
              </p>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td><label>Was safety plan discussed?&nbsp;&nbsp;&nbsp;&nbsp;</label> </td>
                      <td> <label className="radio-inline"><input type="radio" id='SafetyPlanDiscussed_1' name="safetyPlanDiscussed"  className='add-only cursor-pointer' value='1' />&nbsp;Yes &nbsp;&nbsp;</label></td>
                      <td> <label className="radio-inline"><input type="radio" id='SafetyPlanDiscussed_2' name="safetyPlanDiscussed"  className='add-only cursor-pointer' value='0' />&nbsp;No</label></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td><label>Has the client been assessed for suicidal or homicidal ideation?&nbsp;&nbsp;&nbsp;&nbsp;</label> </td>
                      <td> <label className="radio-inline"><input type="radio" id='hiSiAssessed_1' name="hiSiAssessed"  className='add-only cursor-pointer' value='1' />&nbsp;Yes &nbsp;&nbsp;</label></td>
                      <td> <label className="radio-inline"><input type="radio" id='hiSiAssessed_2' name="hiSiAssessed"  className='add-only cursor-pointer' value='0' />&nbsp;No</label></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-12 p-0">
              <p className='mt-0 mb-0'>
                <span className='session-summary'>Session Summary: </span>
                <textarea id="txtSummary" name="sessionSummary" className='add-only mt-3 ai-notes-text'></textarea>
              </p>
              <h5 className="fw-600 radio-label-head mb-2">Observations</h5>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Appearance</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">
                  <p>
                    <input type='radio' id='Appearance_1' name='Appearance' className='add-only cursor-pointer' value='Neatly' /> Neatly &nbsp; <br />
                    <input type='radio' id='Appearance_2' name='Appearance' className='add-only cursor-pointer' value='UnKempt' /> Unkempt &nbsp; <br />
                    <input type='radio' id='Appearance_3' name='Appearance' className='add-only cursor-pointer' value='Inappropriate' /> Inappropriate &nbsp; <br />
                    <input type='radio' id='Appearance_4' name='Appearance' className='add-only cursor-pointer' value='Bizarre' /> Bizarre &nbsp; <br />
                    <input type='radio' id='Appearance_5' name='Appearance' className='add-only cursor-pointer' value='Appropriately' /> Appropriately
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Speech</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">

                  <p>
                    <input type='radio' id='Speech_1' name='Speech' className='add-only cursor-pointer' value='Logical' /> Logical &nbsp; <br />
                    <input type='radio' id='Speech_2' name='Speech' className='add-only cursor-pointer' value='Coherent' /> Coherent &nbsp; <br />
                    <input type='radio' id='Speech_3' name='Speech' className='add-only cursor-pointer' value='Disorganized' /> Disorganized &nbsp; <br />
                    <input type='radio' id='Speech_4' name='Speech' className='add-only cursor-pointer' value='Pressured' /> Pressured &nbsp; <br />
                    <input type='radio' id='Speech_5' name='Speech' className='add-only cursor-pointer' value='Erratic' /> Erratic
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Affect</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">
                  <p>
                    <input type='radio' id='Affect_1' name='Affect' className='add-only cursor-pointer' value='Full' /> Full &nbsp; <br />
                    <input type='radio' id='Affect_2' name='Affect' className='add-only cursor-pointer' value='Constricted' /> Constricted &nbsp; <br />
                    <input type='radio' id='Affect_3' name='Affect' className='add-only cursor-pointer' value='Tearful' /> Tearful &nbsp; <br />
                    <input type='radio' id='Affect_4' name='Affect' className='add-only cursor-pointer' value='Flat' /> Flat
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Attitude</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">
                  <p>
                    <input type='radio' id='Attitude_1' name='Attitude' className='add-only cursor-pointer' value='Cooperative' /> Cooperative &nbsp; <br />
                    <input type='radio' id='Attitude_2' name='Attitude' className='add-only cursor-pointer' value='Pleasent' /> Pleasent &nbsp; <br />
                    <input type='radio' id='Attitude_3' name='Attitude' className='add-only cursor-pointer' value='Uncooperative' /> Uncooperative &nbsp; <br />
                    <input type='radio' id='Attitude_4' name='Attitude' className='add-only cursor-pointer' value='Argumentative' /> Argumentative &nbsp; <br />
                    <input type='radio' id='Attitude_5' name='Attitude' className='add-only cursor-pointer' value='Hostile' /> Hostile &nbsp; <br />

                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Mood</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">

                  <p>
                    <input type='checkbox' id='Mood_1' name='Mood' className='add-only cursor-pointer' value='Euthymic' /> Euthymic &nbsp; <br />
                    <input type='checkbox' id='Mood_2' name='Mood' className='add-only cursor-pointer' value='Anxious' /> Anxious &nbsp; <br />
                    <input type='checkbox' id='Mood_3' name='Mood' className='add-only cursor-pointer' value='Angry' /> Angry &nbsp; <br />
                    <input type='checkbox' id='Mood_4' name='Mood' className='add-only cursor-pointer' value='Depressed' /> Depressed &nbsp; <br />
                    <input type='checkbox' id='Mood_5' name='Mood' className='add-only cursor-pointer' value='Euphoric' /> Euphoric &nbsp; <br />
                    <input type='checkbox' id='Mood_6' name='Mood' className='add-only cursor-pointer' value='Irritable' /> Irritable &nbsp; <br />
                    <input type='checkbox' id='Mood_7' name='Mood' className='add-only cursor-pointer' value='Apathetic' /> Apathetic &nbsp; <br />
                    <input type='checkbox' id='Mood_8' name='Mood' className='add-only cursor-pointer' value='Calm' /> Calm &nbsp; <br />
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 p-0">
              <h5 className="fw-600 radio-label-head mb-2">Cognition</h5>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Orientation</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">

                  <p>
                    <input type='radio' id='Orientation_1' name='Orientation' className='add-only cursor-pointer' value='None' /> None &nbsp; <br />
                    <input type='radio' id='Orientation_2' name='Orientation' className='add-only cursor-pointer' value='Place' /> Place &nbsp; <br />
                    <input type='radio' id='Orientation_3' name='Orientation' className='add-only cursor-pointer' value='Situation' /> Situation &nbsp; <br />
                    <input type='radio' id='Orientation_4' name='Orientation' className='add-only cursor-pointer' value='Person' /> Person &nbsp; <br />
                    <input type='radio' id='Orientation_5' name='Orientation' className='add-only cursor-pointer' value='Time' /> Time
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Attention</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">
                  <p>
                    <input type='radio' id='Attention_1' name='Attention' className='add-only cursor-pointer' value='Alert' /> Alert &nbsp; <br />
                    <input type='radio' id='Attention_2' name='Attention' className='add-only cursor-pointer' value='Distracted' /> Distracted &nbsp; <br />
                    <input type='radio' id='Attention_3' name='Attention' className='add-only cursor-pointer' value='Inattentive' /> Inattentive


                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Hallucinations</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">
                  <p>
                    <input type='radio' id='Hallucinations_1' name='Hallucinations' className='add-only cursor-pointer' value='None' /> None &nbsp; <br />
                    <input type='radio' id='Hallucinations_2' name='Hallucinations' className='add-only cursor-pointer' value='Auditory' /> Auditory &nbsp; <br />
                    <input type='radio' id='Hallucinations_3' name='Hallucinations' className='add-only cursor-pointer' value='Visual' /> Visual &nbsp; <br />
                    <input type='radio' id='Hallucinations_4' name='Hallucinations' className='add-only cursor-pointer' value='Tactile' /> Tactile
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 p-0">
              <h5 className="fw-600 radio-label-head mb-2">Thoughts</h5>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Suicidality</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">
                  <p>
                    <input type='radio' id='Suicidality_1' name='Suicidality' className='add-only cursor-pointer' value='None' /> None &nbsp; <br />
                    <input type='radio' id='Suicidality_2' name='Suicidality' className='add-only cursor-pointer' value='Ideation' /> Ideation &nbsp; <br />
                    <input type='radio' id='Suicidality_3' name='Suicidality' className='add-only cursor-pointer' value='Plan' /> Plan &nbsp; <br />
                    <input type='radio' id='Suicidality_4' name='Suicidality' className='add-only cursor-pointer' value='Intent' /> Intent &nbsp; <br />
                    <input type='radio' id='Suicidality_5' name='Suicidality' className='add-only cursor-pointer' value='Self-Harm' /> Self-Harm
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Homicidality</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">
                  <p>
                    <input type='radio' id='Homicidality_1' name='Homicidality' className='add-only cursor-pointer' value='None' /> None &nbsp; <br />
                    <input type='radio' id='Homicidality_2' name='Homicidality' className='add-only cursor-pointer' value='Aggressive' /> Aggressive &nbsp; <br />
                    <input type='radio' id='Homicidality_3' name='Homicidality' className='add-only cursor-pointer' value='Intent' /> Intent &nbsp; <br />
                    <input type='radio' id='Homicidality_4' name='Homicidality' className='add-only cursor-pointer' value='Plan' /> Plan
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Delusions</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">
                  <p>
                    <input type='radio' id='Delusions_1' name='Delusions' className='add-only cursor-pointer' value='None' /> None &nbsp; <br />
                    <input type='radio' id='Delusions_2' name='Delusions' className='add-only cursor-pointer' value='Grandiose' /> Grandiose &nbsp; <br />
                    <input type='radio' id='Delusions_3' name='Delusions' className='add-only cursor-pointer' value='Paranoid' /> Paranoid &nbsp; <br />
                    <input type='radio' id='Delusions_4' name='Delusions' className='add-only cursor-pointer' value='Religious' /> Religious &nbsp; <br />
                    <input type='radio' id='Delusions_5' name='Delusions' className='add-only cursor-pointer' value='Other' /> Other
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 p-0">
              <h5 className="fw-600 radio-label-head mb-2">Behavior</h5>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Behavior</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">

                  <p>
                    <input type='checkbox' id='Behavior_1' name='Behavior_1' className='add-only cursor-pointer' value='Cooperative' /> Cooperative &nbsp; <br />
                    <input type='checkbox' id='Behavior_2' name='Behavior_2' className='add-only cursor-pointer' value='Gaurded' /> Guarded  &nbsp; <br />
                    <input type='checkbox' id='Behavior_3' name='Behavior_3' className='add-only cursor-pointer' value='Hyperactive' /> Hyperactive &nbsp; <br />
                    <input type='checkbox' id='Behavior_4' name='Behavior_4' className='add-only cursor-pointer' value='Agitated' /> Agitated &nbsp; <br />
                    <input type='checkbox' id='Behavior_5' name='Behavior_5' className='add-only cursor-pointer' value='Paranoid' /> Paranoid &nbsp; <br />
                    <input type='checkbox' id='Behavior_6' name='Behavior_6' className='add-only cursor-pointer' value='Stereotyped' /> Stereotyped &nbsp; <br />
                    <input type='checkbox' id='Behavior_7' name='Behavior_7' className='add-only cursor-pointer' value='Aggressive' /> Aggressive &nbsp; <br />
                    <input type='checkbox' id='Behavior_8' name='Behavior_8' className='add-only cursor-pointer' value='Bizare' /> Bizarre &nbsp; <br />
                    <input type='checkbox' id='Behavior_9' name='Behavior_9' className='add-only cursor-pointer' value='Withdrawn' /> Withdrawn
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Insight</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">
                  <p>
                    <input type='radio' id='Insight_1' name='Insight' className='add-only cursor-pointer' value='Good' /> Good &nbsp; <br />
                    <input type='radio' id='Insight_2' name='Insight' className='add-only cursor-pointer' value='Fair' /> Fair &nbsp; <br />
                    <input type='radio' id='Insight_3' name='Insight' className='add-only cursor-pointer' value='Poor' /> Poor
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
              <h6 className="mb-2">Judgement</h6>
              <div className="form-group mb-3 radio-form-grp">
                <div className="radio-sub-form">
                  <p>
                    <input type='radio' id='Judgement_1' name='Judgement' className='add-only cursor-pointer' value='Good' /> Good &nbsp; <br />
                    <input type='radio' id='Judgement_2' name='Judgement' className='add-only cursor-pointer' value='Fair' /> Fair &nbsp; <br />
                    <input type='radio' id='Judgement_3' name='Judgement' className='add-only cursor-pointer' value='Poor' /> Poor
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 p-0 mb-3">
              <h6 className="mb-2">Attach File(s) to the document</h6>
              <Upload
                batch={false}
                multiple={true}
                autoUpload={false}
                files={attachments}
                defaultFiles={attachments}
                onAdd={onAdd}
                onRemove={onRemove}
                onStatusChange={onStatusChange}
                withCredentials={false}
                showActionButtons={false}
                ariaDescribedBy={"firstNameError"}
              />
              {uploadError && <Error>Document is required</Error>}
            </div>
          </div>
        </div>
      </div>
    </form >
  )
}